import { QUESTION_FILE_UPLOAD_STORE_NAME, getFileQuestionsDb } from './dbService'

export class WebPlayQuestionFileUploadStorageService {
  constructor(playbookId) {
    this.playbookId = playbookId
  }

  async getDbLazy() {
    if (!this.db) {
      this.db = await getFileQuestionsDb(this.playbookId)
    }
    return this.db
  }

  async saveFile(question, currentHeader, file) {
    const db = await this.getDbLazy()
    return new Promise((resolve, reject) => {
      const header = {
        id: currentHeader.id,
        name: currentHeader.name,
      }
      const fileItem = { questionId: question.id, header: header, file: file }

      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readwrite')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .add(fileItem)

      request.onsuccess = function () {
        resolve(this.result)
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }

  async deleteFile(fileItem) {
    const db = await this.getDbLazy()
    return new Promise((resolve, reject) => {
      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readwrite')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .delete(fileItem.id)

      request.onsuccess = function () {
        resolve()
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }

  async getAll(question) {
    const db = await this.getDbLazy()
    return new Promise(async (resolve, reject) => {
      const fileItems = []
      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readonly')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .openCursor()

      request.onsuccess = function () {
        const cursor = this.result

        if (cursor) {
          if (!question || cursor.value.questionId === question.id) {
            fileItems.push(cursor.value)
          }
          cursor.continue()
        } else {
          resolve(fileItems)
        }
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }
}
